module.exports = __webpack_public_path__ + "img/s_marker_selected.0a360c32.svg";